import { StatsManfreditesResponse } from '@asgard/api-common';
import {
  ManfreditesStats,
  ManfreditesStatsSchema
} from 'model/manfredites-stats/model.manfredites-stats';

export function normalizeToManfrediteStats(
  res: StatsManfreditesResponse
): ManfreditesStats {
  if (!res.hasEnoughManfredites) {
    return {
      hasEnoughManfredites: false
    };
  }

  const data: ManfreditesStats = {
    hasEnoughManfredites: res.hasEnoughManfredites,
    stats: res.stats
      ? {
          manfreditesCount: res.stats.manfreditesCount,
          salariesHeatMap: {
            salaryLabels: res.stats.salariesHeatMap.salaryLabels,
            experienceLabels: res.stats.salariesHeatMap.experienceLabels,
            heatMap: res.stats.salariesHeatMap.heatMap.map((row) =>
              row.map((value) => value)
            )
          },
          remoteOptionsPercentages: {
            remote: res.stats.remoteOptionsPercentages.remote,
            hybrid: res.stats.remoteOptionsPercentages.hybrid,
            onSite: res.stats.remoteOptionsPercentages.onSite
          },
          manfredites: res.stats.manfredites.map((manfredite) => ({
            roles: manfredite.roles,
            mainTechs: manfredite.mainTechs,
            techs: manfredite.techs,
            experienceRange: manfredite.experienceRange,
            salaryRange: manfredite.salaryRange,
            wantsRemote: manfredite.wantsRemote,
            wantsHybrid: manfredite.wantsHybrid,
            wantsFaceToFace: manfredite.wantsFaceToFace,
            contractTypes: manfredite.contractTypes,
            lastUpdateIsoString: manfredite.lastUpdate
              ? new Date(manfredite.lastUpdate).toISOString()
              : undefined
          }))
        }
      : undefined
  };

  const result = ManfreditesStatsSchema.safeParse(data);

  if (!result.success) {
    return data;
  }

  return result.data;
}
